import { HoursProps } from '../../../interfaces/props/SaudeOnline/HoursProps';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import './styles.css'
import { sxRadio } from './sxProps';
import { useEffect, useState } from 'react';
import { Horarios } from '../../../interfaces/entities/Horarios';
import { useAccessibility } from '../../../Store/contexts/AccessibilityContext';
import { dateToText } from '../../../utils/MonthMap';

function Hours(props: HoursProps){
    const [hours, setHours] = useState<Horarios[]>([]);
    const [value, setValue] = useState<string>('');

    const accessibility = useAccessibility();

    useEffect(() => {
        const selectedDate = props.selectedDate;
        if(selectedDate !== null){
            const selectedHours = props.hoursList.filter(hour => hour.data === `${String(selectedDate.getDate()).padStart(2, '0')}/${String(selectedDate.getMonth() + 1).padStart(2, '0')}/${selectedDate.getFullYear()}`);
            setHours(selectedHours)
        }

    }, [props.selectedDate, props.hoursList]);

    useEffect(() => {
        if(props.selectedHour !== null){
            
            const selectedHour = props.selectedHour;
            const index = hours.findIndex((hour: Horarios) => hour.hora === selectedHour.hora && hour.data === selectedHour.data);
            setValue(`${index}`);
        }
        else {
            setValue('')
        }
        
    }, [hours, props.selectedHour])

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setValue(event.target.value);
        props.handleHour(hours[Number(event.target.value)])
    };

    return (
        <div className="hours-holder">
            {props.selectedDate !== null &&
                <div>
                    <h1 className='hours-title-agendar-consulta' style={accessibility.textStyleAccessibility}>Horários disponíveis</h1>

                    <div className="hours" style={accessibility.contrastStyle}>
                            <h1 className='hours-holder-title' style={accessibility.textStyleAccessibility}>Selecione o horário para agendamento</h1>
                            {hours.length > 0 &&
                                <RadioGroup
                                    aria-labelledby="demo-radio-buttons-group-label"
                                    name="radio-buttons-group"
                                    value={value}
                                    onChange={handleChange}
                                >
                                    {hours.map((hour: Horarios, index: number) => {
                                        return(
                                            <FormControlLabel 
                                                value={index} 
                                                control={<Radio size='small'style={accessibility.textStyleAccessibility}/>} 
                                                label={`${hour.data} (${hour.diaSemana}) - ${hour.hora}`}
                                                aria-label={`${dateToText(hour.data)} (${hour.diaSemana}) - ${hour.hora}`}
                                                key={hour.hora} 
                                                sx={sxRadio}
                                            />
                                        )
                                    })}
                                </RadioGroup> 
                            }
                            {hours.length === 0 &&
                                <h1 className='hours-holder-message' style={accessibility.textStyleAccessibility}>Data indisponível. Selecione outra data.</h1>
                            }
                        </div> 
                    
                </div> 
            }
        </div>
    )
}

export default Hours;